if (!customElements.get('meet-the-team')) {
  class MeetTheTeam extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.dialog = this.querySelector('[data-team-dialog]');
      this.dialogContent = this.querySelector('[data-team-dialog-content]');
      this.closeButton = this.querySelector('[data-team-close]');

      if (!this.dialog || !this.dialogContent || !this.closeButton) return;

      this.initialized = true;

      this.querySelectorAll('[data-team-open]').forEach((button) => {
        button.addEventListener('click', () => this.openProfile(button));
      });

      this.closeButton.addEventListener('click', () => this.closeProfile());
      this.dialog.addEventListener('click', (event) => this.handleBackdropClick(event));
      this.dialog.addEventListener('close', () => this.handleClose());
    }

    openProfile(button) {
      const profile = this.querySelector(`#${CSS.escape(button.dataset.teamOpen)}`);
      if (!profile) return;

      this.activeButton = button;
      this.dialogContent.replaceChildren(profile.content.cloneNode(true));

      const title = this.dialogContent.querySelector('h2');
      if (title) this.dialog.setAttribute('aria-labelledby', title.id);

      this.dialog.showModal();
      document.documentElement.classList.add('overflow-hidden');
      this.closeButton.focus();
    }

    closeProfile() {
      if (this.dialog.open) this.dialog.close();
    }

    handleBackdropClick(event) {
      if (event.target !== this.dialog) return;

      const bounds = this.dialog.getBoundingClientRect();
      const clickedInside = event.clientX >= bounds.left
        && event.clientX <= bounds.right
        && event.clientY >= bounds.top
        && event.clientY <= bounds.bottom;

      if (!clickedInside) this.closeProfile();
    }

    handleClose() {
      document.documentElement.classList.remove('overflow-hidden');
      this.dialogContent.replaceChildren();
      if (this.activeButton) this.activeButton.focus();
    }
  }

  customElements.define('meet-the-team', MeetTheTeam);
}
